import {Component, HostListener, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {User} from './shared/models/user.model';
import {AuthService} from './shared/services/auth.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ROLE} from './shared/const/mock-selectize-config';
import {IconService} from "./shared/services/icon.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
    svgStyle: Object;
    subscription_1: Subscription;
    isCollapsed?: boolean;
    userChecked = false;
    user: User = null;
    isLoggedIn = false;
    userRole = null;
    isAdmin: boolean;
    innerWidth?: number;
    constructor(private translate: TranslateService,
                private authService: AuthService,
                private iconService: IconService,
                private router: Router) {
        this.svgStyle = { 'width.px': 32, 'height.px': 32 };
        if (localStorage.getItem('language')) {
            translate.setDefaultLang(localStorage.getItem('language'));
            translate.use(localStorage.getItem('language'));
        } else {
            translate.setDefaultLang('sv');
            translate.use('sv');
            localStorage.setItem('language', 'sv');
        }
    }

    onChangedLang(lang: string) {
      this.translate.use(lang);
      localStorage.setItem('language', lang);
    }

    ngOnInit() {
        this.innerWidth = window.innerWidth;
        this.subscription_1 = this.authService.getAuth().subscribe((auth) => {
            this.isLoggedIn = auth.isLogIn;
            this.user = auth.user;
            this.userChecked = true;
            if (auth.user) {
                for (let r of auth.user.role) {
                    if (r.name === ROLE.admin || r.name === ROLE.superAdmin) {
                      this.isAdmin = true;
                    } else {
                      this.isAdmin = false;
                    }
                }
            }
        });
    }

    logOut() {
        this.authService.logout();
        const checkLogin = this.authService.isLoggedIn();
        this.user = null;
        if (!checkLogin) {
            this.router.navigate(['/login']);
        }
    }

    clickShowMenu(showMenu: HTMLButtonElement) {
        if (this.innerWidth <= 991) {
            showMenu.click();
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
    }
}
